import Text from "components/Common/Text";
import { motion } from "framer-motion";
/* eslint-disable react/prop-types */
export default function Best2BestBallBar({
  showTitleBar,
  showScoreByIndex,
  showTotal,
  teamName,
  scoreByIndex,
  holeIndex,
  net,
}) {
  const minimumTwoBalls = scoreByIndex
    ?.reduce((acc, curr) => {
      curr.forEach((value, arrIndex) => {
        if (acc[arrIndex] === undefined) {
          acc[arrIndex] = [];
        }
        if (value !== null) {
          acc[arrIndex].push(value);
        }
      });
      return acc;
    }, [])
    .map((column) => {
      const sortedColumn = column.sort((a, b) => a - b);
      return { ball2: sortedColumn[0], ball1: sortedColumn[1] };
    })
    .map((value) =>
      value.ball1 && value.ball2 ? value : { ball1: null, ball2: null },
    );

  const ball2 = minimumTwoBalls?.[holeIndex].ball2;
  const ball1 = minimumTwoBalls?.[holeIndex].ball1;

  function ball2Sum() {
    return minimumTwoBalls?.reduce((acc, curr) => acc + curr.ball2, 0);
  }

  function ball1Sum() {
    return minimumTwoBalls?.reduce((acc, curr) => acc + curr.ball1, 0);
  }

  const style = {
    height: 50,
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const fadeInAnimation = {
    initial: { opacity: 0, x: -100 },
    animate: { opacity: 1, x: 0 },
  };

  const titleBar = () => (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <motion.div style={style} {...fadeInAnimation}>
      <Text as="C1" style={{ color: "#66707A" }}>
        {teamName} ball 1 {net ? "net" : "gross"}
      </Text>
      <Text as="C1" style={{ color: "#66707A" }}>
        {teamName} ball 2 {net ? "net" : "gross"}
      </Text>
    </motion.div>
  );

  const scoreBar = () => (
    <motion.div style={style} {...fadeInAnimation}>
      <Text as="P1" style={{ color: "rgba(30, 38, 46, 0.95)" }}>
        {ball2 ?? "-"}
      </Text>
      <Text as="P1" style={{ color: "rgba(30, 38, 46, 0.95)" }}>
        {ball1 ?? "-"}
      </Text>
    </motion.div>
  );

  const totalBar = () => (
    <motion.div style={style} {...fadeInAnimation}>
      <Text as="P1" style={{ color: "rgba(30, 38, 46, 0.95)" }}>
        {ball2Sum() ?? "-"}
      </Text>
      <Text as="P1" style={{ color: "rgba(30, 38, 46, 0.95)" }}>
        {ball1Sum() ?? "-"}
      </Text>
    </motion.div>
  );
  return (
    <div style={{ maxHeight: 50 }}>
      {showTitleBar && titleBar()}
      {showScoreByIndex && scoreBar()}
      {showTotal && totalBar()}
    </div>
  );
}
